module.exports = __webpack_public_path__ + "img/help8.b97c334f.png";